import React from "react";
import CryptoTable from "./components/CryptoTable";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import { MarketTrend } from "./components/MarketTrend";
import "./index.css";

function App() {
  return (
    <div className="bg-purple-500">
      <Header />
      <HeroSection />
      <MarketTrend />
      <CryptoTable />
    </div>
  );
}

export default App;
